<template>
    <div class="panel bgPanel mt1x cb mr1x ml1x h13x-min box">
        <div class="title title-bg">
            <span :title="$t('word1473',['系统概要'])">{{$t("word1473",["系统概要"])}}</span>
        </div>
        <Loading v-show="isLoading"></Loading>
        <div class="w100pct mt1x clearfix w33pct_E fL_E pl1x_E mb2x_E" v-if="JSON.stringify(result) !='{}'">
             <div>
                <div class="textCut pb1x taL" :title="`${getLanguageStr('word1983','当前报警总数')}(${result.alertCount.total})`">{{getLanguageStr('word1983','当前报警总数')}}({{result.alertCount.total}})</div>
                <div class="tableSys vaT_E">
                    <div class="w4x vaM">
                        <div class="icoSys h3x w3x bgLight taC mr1x">
                            <svg class="ico fSub"><use xlink:href="#alarm"></use></svg>
                        </div>
                    </div>
                    <div>
                        <div class="taL textCut_E w33pct-max_E fL_E clearfix pr1x_E">
                            <div :title="`${result.alertCount.error}${getLanguageStr('word70','故障')}`">
                                <span class="fs16x dpB" :class="{pr05x:result.alertCount.error>999}">{{result.alertCount.error}}<span class="superscript superscript-absMode" v-if="result.alertCount.offline>999">+</span></span>
                               	<span class="mt05x dpB">{{getLanguageStr('word70','故障')}}</span>
                            </div>

                            <div :title="`${result.alertCount.warning}${getLanguageStr('word71','警告')}`">
                                <span class="fs16x dpB" :class="{pr05x:result.alertCount.warning>999}">{{result.alertCount.warning}}<span class="superscript superscript-absMode" v-if="result.alertCount.offline>999">+</span></span>
                                <span class="mt05x dpB">{{getLanguageStr('word71','警告')}}</span>
                            </div>
                             <div :title="`${result.alertCount.remind}${getLanguageStr('manage100','提示')}`">
                                <span class="fs16x dpB" :class="{pr05x:result.alertCount.remind>999}">{{result.alertCount.remind}}<span class="superscript superscript-absMode" v-if="result.alertCount.offline>999">+</span></span>
                                <span class="mt05x dpB">{{getLanguageStr('manage100','提示')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt1x">
                    <div class="cMain pl4x curP" @click="stepTo('alarm')">{{getLanguageStr('cmd155','查看')}}</div>
                </div>
            </div>
            <div v-for="(item,index) in result" :key="index" v-if="index!='alertCount' && item && item.total" class="boxshow">
                <div class="textCut pb1x taL" :title="`${list.title}(${item.total})`" v-for="list in summaryType" :key="list.id" v-if="index==list.type">{{list.title}}({{item.total}})</div>
                <div class="tableSys vaT_E">
                    <div class="w4x vaM">
                        <div class="icoSys h3x w3x bgLight taC mr1x">
                            <svg class="ico fSub"><use v-for="list in summaryType" :key="list.id" v-if="index==list.type" :xlink:href="list.icon"></use></svg>
                        </div>
                    </div>
                    <div>
                        <div class="taL textCut_E w50pct-max_E fL_E clearfix pr1x_E">
                            <div :title="`${item.offline}${getLanguageStr('word1752','台离线')}`">
                                <span class="fs16x dpB">{{item.offline}}</span>
                                <span class="mt05x dpB">{{getLanguageStr('word64','离线')}}</span>
                            </div>
                            <div :title="`${item.alert}${getLanguageStr('word1755','台报警')}`">
                                <span class="fs16x dpB">{{item.alert}}</span>
                                <span class="mt05x dpB">{{getLanguageStr('word27','报警')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt1x">
                    <div class="cMain pl4x curP" @click="stepTo(index)">{{getLanguageStr('cmd155','查看')}}</div>
                </div>
            </div>
        </div>
        <div class="taC pb1x" v-show="showMore">
        	<button class="cSub fSub hover-c-main hover-f-main tra-fast vaM_E" :title="$t('cmd108',['点击展开/收起'])" @click="filterCtrl" :status="filterOptionStatus">
				<Icon name="arrowDouble-d" class="w1x h1x mr05x tra" />
			</button>
        </div>
    </div>
</template>
<script>
import {getLanguageStr} from '@/util/language.js';
import * as equipmentApi from '@/api/maintain/plant/list';
import Loading from '@/components/common/ui/Loading';
import * as lib from '@/util/lib.js';
export default {
	name: 'stationSummary',
	components: {Loading},
	data () {
		return {
        	filterOptionStatus: 'show', // 参数选择展开状态控制
			isLoading: true,
			showMore: false,
			summaryType: [{
				type: 'alertCount',
				title: getLanguageStr('word342', '报警总数'),
				tag: 'alarm',
				icon: '#alarm',
				id: 0,
				statisticCode: {a: 'A13', b: 'A1302'}
			}, {
				type: 'inverterCount',
				title: getLanguageStr('word1750', '逆变器总数'),
				tag: 'InverterList',
				icon: '#dv-inverter',
				id: 1,
				statisticCode: {a: 'A13', b: 'A1303'}
			}, {
				type: 'meterCount',
				title: getLanguageStr('word1756', '电表总数'),
				tag: 'AmmeterList',
				icon: '#dv-meter',
				id: 2,
				statisticCode: {a: 'A13', b: 'A1304'}
			}, {
				type: 'pvModuleCount',
				title: getLanguageStr('word1758', '组件总数'),
				tag: 'ComponetList',
				icon: '#dv-comp',
				id: 3,
				statisticCode: {a: 'A13', b: 'A1305'}
			}, {
				type: 'weatherStationCount',
				title: getLanguageStr('word1759', '气象站总数'),
				tag: 'WeatherList',
				icon: '#dv-weatherStation',
				id: 4,
				statisticCode: {a: 'A13', b: 'A1306'}
			}, {
				type: 'microInverterCount',
				title: getLanguageStr('plant_detail1', '微逆总数'),
				tag: 'MicroInverterList',
				icon: '#dv-microInverter',
				id: 5,
				statisticCode: {a: 'A13', b: 'A1307'}
			}, {
				type: 'combinerBoxCount',
				title: getLanguageStr('plant_detail2', '汇流箱总数'),
				tag: 'CombinerBoxList',
				icon: '#dv-combinerBox',
				id: 6,
				statisticCode: {a: 'A13', b: 'A1308'}
			}, {
				type: 'repeaterCount',
				title: getLanguageStr('plant_detail3', '中继器总数'),
				tag: 'RepeaterList',
				icon: '#dv-repeater',
				id: 7,
				statisticCode: {a: 'A13', b: 'A1309'}
			}, {
				type: 'batteryCount',
				title: getLanguageStr('plant_detail4', '电池总数'),
				tag: 'BatteryList',
				icon: '#dv-battery',
				id: 8,
				statisticCode: {a: 'A13', b: 'A1310'}
			},
			{
				type: 'collectorCount',
				title: getLanguageStr('word1761﻿', '采集器总数'),
				tag: 'CollectorList',
				icon: '#dv-logger',
				id: 9,
				statisticCode: {a: 'A13', b: 'A1311'}
			}, {
				type: 'dtuCount',
				title: getLanguageStr('plant_detail5', 'DTU总数'),
				tag: 'DTUList',
				icon: '#dv-DTU',
				id: 10,
				statisticCode: {a: 'A13', b: 'A1312'}
			},
			{
				type: 'fanCount',
				title: getLanguageStr('plant393', '风机总数'),
				tag: 'FANList',
				icon: '#dv-fan',
				id: 11,
				statisticCode: {a: 'A13', b: 'A1313'}
			}
			],
			basicInfo: {},
			result: {}
		};
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		floatFix: lib.floatFix,
		convertData: lib.convertData,
		filterCtrl: function (action) { // 参数选择展开收起的交互效果
			let $box = $(this.$el).find('.boxshow:gt(4)');
			// let $btn=$box.parents(".panel").first().find(".tool [status]");
			if (['show', 'hide'].indexOf(action) < 0) action = this.filterOptionStatus == 'show' ? 'hide' : 'show';
			switch (action) {
			case 'show':
				$box.slideDown(500, 'easeInOutExpo');
				this.filterOptionStatus = 'show';
				break;
			case 'hide':
				$box.slideUp(500, 'easeInOutExpo');
				this.filterOptionStatus = 'hide';
				break;
			}
		},
		show (data) {
			if (data.level == 0) {
				this._getList(data.stationId, null);
			} else {
				this._getList(data.stationId, data.systemId);
			}
		},
		_getList (id, sysId) {
			this.result = {};
			this.isLoading = true;
			equipmentApi.StationSummary(id, {systemId: sysId}).then(res => {
				this.result = res;
				this.isLoading = false;
				this.$nextTick(() => {
                	let l = $(this.$el).find('.boxshow').length;
                	if (l > 5) {
                		this.filterCtrl('hide');
                		this.showMore = true;
                	} else {
                		this.showMore = false;
                	}
				});
				//  $(this.$el).find('.boxshow:gt(4)').hide();
				// for(let key in this.result){
				//     for(let attr in this.summaryType){
				//         if(this.summaryType[attr].type==key){
				//             this.result[key]={data:{...this.result[key]},...this.summaryType[attr]}
				//         }
				//     }
				// }
			}, error => {
				this.isLoading = false;
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		stepTo (index) {
			let tag = null;
			if (index != 'alarm') {
				for (let attr in this.summaryType) {
					if (this.summaryType[attr].type == index) {
						statistic(this.summaryType[attr].statisticCode.a, this.summaryType[attr].statisticCode.b);
						tag = this.summaryType[attr].tag;
					}
				}
			} else {
				statistic('A13', 'A1302');
				tag = index;
			}
			this.$emit('stepTo', tag);
		}
	}
};
</script>
<style lang="scss" scoped>
    .panel .title{ margin-bottom: 0 }
    .superscript{min-width: auto;padding: 0;background: #fff;color: #323232}
    [status="show"] svg{transform:rotate(180deg);}
	[status="hide"] svg{transform:rotate(0);}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/StationSummary.vue